// Models
import { OptIn, PaymentDetails } from 'models/PaymentDetails'

// Redux services
import { createConsentDecision } from 'redux/services/consentDecision'

// Local
import { RootState, TypedDispatch } from 'redux/store'

const getConsentDetails = ({
  paymentDetails,
  supporterId,
  type,
}: {
  paymentDetails: PaymentDetails
  supporterId: number
  type: keyof OptIn
}) => ({
  supporterId: supporterId,
  opted_in: paymentDetails.optIn[type].canContact ?? false,
  language: paymentDetails.optIn[type].canContactText,
  type,
})

const saveConsentDetails = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  supporterId: number,
): Promise<void> => {
  await Promise.all(
    Object.entries(store.order.paymentDetails.optIn)
      .filter(([, { canContact }]) => canContact === true)
      .map(([key]) =>
        dispatch(
          createConsentDecision.initiate(
            getConsentDetails({
              paymentDetails: store.order.paymentDetails,
              supporterId,
              type: key as keyof OptIn,
            }),
          ),
        ).unwrap(),
      ),
  )
}

export default saveConsentDetails
